import { useState } from 'react';

import { Box, Chip, CircularProgress, IconButton, MenuItem, Select } from '@mui/material';
import Check from '@mui/icons-material/Check';

import { BaseEditControlProps, TextDataTypes } from '../Table.types';

export const SelectEditControl = ({
  initialValue,
  values,
  onSubmitChange,
  isSaving,
}: BaseEditControlProps<TextDataTypes>) => {
  const [value, setValue] = useState(initialValue);

  return (
    <Box display="flex" width="100%" alignItems="center" justifyContent="space-between">
      <Select
        displayEmpty
        variant="standard"
        fullWidth
        value={value}
        renderValue={selected =>
          Array.isArray(selected) ? (
            <Box display="flex" flexWrap="wrap">
              {selected.map(value => (
                <Chip key={value} label={values?.find(el => el === value)} />
              ))}
            </Box>
          ) : (
            values?.find(el => el === selected)
          )
        }
        onChange={e => setValue(e.target.value as string)}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {values?.map(value => (
          <MenuItem key={value} value={value} data-testid={value}>
            {value}
          </MenuItem>
        ))}
      </Select>

      <IconButton
        disableFocusRipple={true}
        disableRipple
        disabled={isSaving || value === initialValue}
        onClick={() => onSubmitChange(value)}
        size="small"
      >
        {isSaving ? (
          <CircularProgress color="primary" variant="indeterminate" size={16} />
        ) : (
          <Check fontSize="small" />
        )}
      </IconButton>
    </Box>
  );
};
